// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/about-background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-title {
    font-family: 'Poppins';
    padding: 20px 20px 0px 20px;
    margin: 0;
}

.about-text {
    font-family: 'Poppins';
    padding: 0px 20px;
}

.about-section {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 92vh;
}
`, "",{"version":3,"sources":["webpack://./src/style/AboutStyle.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,yDAAuD;IACvD,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,YAAY;AAChB","sourcesContent":[".about-title {\n    font-family: 'Poppins';\n    padding: 20px 20px 0px 20px;\n    margin: 0;\n}\n\n.about-text {\n    font-family: 'Poppins';\n    padding: 0px 20px;\n}\n\n.about-section {\n    background-image: url('../images/about-background.jpg');\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    height: 92vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
